import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadCoffeeMachine = () => {
    const promiseCoffeeMachine = new Promise((resolve, reject) => {
        loader.load(
            "office/model/coffeemachine/coffeemachine.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                model.position.set(-3.8217686860395204, 0.5803597447910289, 4.090318070925657);
                model.scale.set(0.014, 0.014, 0.014);
                model.rotation.set(0, 0, 0);

                model.traverse(function (object) {
                    if (object.isMesh) {
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseCoffeeMachine;
};

export { loadCoffeeMachine };
